export default __webpack_public_path__ + "static/media/330_dummy2016-tattoo01-mobile-de.0d34c08b.png";